import { render } from "./ModalTelefEmailForm.vue?vue&type=template&id=64dd62af&ts=true"
import script from "./ModalTelefEmailForm.vue?vue&type=script&lang=ts"
export * from "./ModalTelefEmailForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__